const Create = (permissions: any, requiredRole: string, component?: any) => {
  const result = permissions && permissions['access_roles'][requiredRole] && permissions['access_roles'][requiredRole]['create'];

  if (result) {
    if (component) {
      return component;
    } else {
      return true;
    }
  }
  return false;
};

export default Create;



// WEBPACK FOOTER //
// ./src/views/Common/Utils/AccessCheck/Create.tsx